export default [
    {value: 1, label: 'Crédito Nuevo'},
    {value: 2, label: 'Novación'},
    {value: 5, label: 'Inicialización'}
]